import { Box, Card, CardActionArea, type SxProps } from "@mui/material";
import { overviewCardStyle } from "./backofficeTheme";

const _cardWidth = 200;
const _cardHeight = 260;
const _cardSpacing = 20;

interface CardsGridProps {
  sx?: SxProps;
  children: Array<React.ReactElement>;
}

interface CardProps {
  sx?: SxProps;
  onClick?: () => void;
}

interface CardsGridType {
  (props: CardsGridProps): React.ReactElement;

  Card: (props: React.PropsWithChildren<CardProps>) => React.ReactElement;
}

function _CardsGrid({ sx, children }: CardsGridProps) {
  return (
    <Box
      sx={{
        ...sx,
        display: "grid",
        gridTemplateColumns: `repeat(auto-fill, minmax(${_cardWidth}px, 1fr))`,
        rowGap: `${_cardSpacing}px`,
        columnGap: `${_cardSpacing}px`,
      }}
    >
      {children}
    </Box>
  );
}

function _CardsGridCard({ children, sx, onClick }: React.PropsWithChildren<CardProps>) {
  return (
    <Card
      sx={[
        overviewCardStyle,
        {
          width: `${_cardWidth}px`,
          height: `${_cardHeight}px`,
          padding: onClick ? 0 : "20px",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {onClick ? (
        <CardActionArea sx={{ padding: "20px", height: "100%" }} onClick={onClick}>
          {children}
        </CardActionArea>
      ) : (
        children
      )}
    </Card>
  );
}

export const CardsGrid: CardsGridType = _CardsGrid as any;
CardsGrid.Card = _CardsGridCard;
